import gsap from "gsap";
// IFRAME
function magnificPopupIframe(){
	$('.magnific-video').magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-video-wrapper',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
	
		iframe: {
			markup: '<div class="mfp-iframe-scaler">' +
				'<div class="mfp-close"></div>' +
				'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
				'</div>',
			patterns: {
				youtu: {
					index: 'youtu.be',
					id: function( url ) {
					
						// Capture everything after the hostname, excluding possible querystrings.
						var m = url.match( /^.+youtu.be\/([^?]+)/ );
				
						if ( null !== m ) {
							return m[1];
						}
				
						return null;
			
					},
					// Use the captured video ID in an embed URL. 
					// Add/remove querystrings as desired.
					src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
				},
				youtube: {
					index: 'youtube.com/',
					id: 'v=',
					src: 'https://www.youtube.com/embed/%id%?autoplay=1'
				},
				vimeo: {
					index: 'vimeo.com/', 
					id: function(url) {        
						var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
						if ( !m || !m[5] ) return null;
						return m[5];
					},
					src: 'https://player.vimeo.com/video/%id%?autoplay=1'
				}
			}
		}
	});
}

// INLINE
function magnificPopupInline(){
	$('.magnific-inline-popup').magnificPopup({
		type: 'inline',
	
		fixedContentPos: false,
		fixedBgPos: true,
	
		overflowY: 'auto',
    closeBtnInside: true,
    preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in',
    callbacks: {
      open: function() { 
          $('.js-close-popup').on('click',function(event){
            event.preventDefault();
            $.magnificPopup.close();
          }); 
      }
    }
	});
}


// Inline with prev next buttons
function magnificPopupSlider() {
  $( '.modal-popup-slider' ).each(function() { 
    let popupSlider = $( this ).magnificPopup({
      mainClass: 'slider-popup',
      type: 'inline',
      fixedContentPos: false,
      fixedBgPos: true,
      overflowY: "auto",
      delegate: 'a.magnific-inline-slider-popup',
      preload: [0,2],
      gallery:{
        enabled: true,
      },
      closeMarkup: '<button title="%title%" type="button" class="mfp-close"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:none;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><title/><g id="cross"><line class="cls-1" x1="7" x2="25" y1="7" y2="25"/><line class="cls-1" x1="7" x2="25" y1="25" y2="7"/></g></svg></button>',
      closeOnContentClick: false,
      removalDelay: 400,
      callbacks: {
        open: function() {
          // Open animation
          gsap.fromTo( '.mfp-container', { y: 50, opacity: 0 }, { y: 0, opacity: 1, ease: "power2.out" } )
        },
        beforeClose: function() {
          // Close animation
          gsap.fromTo( '.mfp-container', { y: 0, opacity: 1, }, { y: 50, opacity: 0, ease: "power2.out", duration: 0.4 } )
        },
        close: function() {
        }
      }
    });


    // Custom navigation.
    var magnificPopup = $.magnificPopup.instance;

    $('body').on('click', '.js-magnific-prev', function( e ) {
      e.preventDefault();
      magnificPopup.prev();
    });
    $('body').on('click', '.js-magnific-next', function( e ) {
      e.preventDefault();
      magnificPopup.next();
    });
  });
}




// GALLERY SINGLE IMAGE
function magnificPopupSingleImage(){
	$('.magnific-gallery-single-image').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		mainClass: 'mfp-img-single',
		image: {
			verticalFit: true,
			titleSrc: function titleSrc(item) {
			return item.el.attr('title');
			}
		},
		gallery: {
			enabled: false
		}
	});          
}

// GALLERY IMAGE
function magnificPopupGalleryImage(){
	$('.magnific-gallery-image').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		mainClass: 'mfp-img-mobile',
		image: {
			verticalFit: true,
			titleSrc: function(item) {
				return item.el.attr('title');
			}
		},
		gallery:{
			enabled:true
		}
	});
}

export { magnificPopupIframe, magnificPopupInline, magnificPopupSingleImage, magnificPopupGalleryImage, magnificPopupSlider };
